<app-typeFNS-simple-desc-marche
[uid]="getUid()"
[parentForm]="parentForm"

[disabled]="disabled"
[natureMarche]="fnSimpleInitial.natureMarche"
></app-typeFNS-simple-desc-marche>